var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "orderList" },
    [
      _c(
        "el-row",
        { staticClass: "my-wrap", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { staticClass: "index-left", attrs: { span: 17 } },
            [
              _c("el-col", { staticClass: "index-lists", attrs: { span: 9 } }, [
                _c(
                  "div",
                  { staticClass: "list-search" },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c("el-input", {
                              staticClass: "my-input",
                              attrs: {
                                clearable: "",
                                placeholder:
                                  _vm.placeholder || "输入问题单号按回车查询",
                                "prefix-icon": "el-icon-search",
                                showArrow: false
                              },
                              on: { change: _vm.onListSearch },
                              model: {
                                value: _vm.myInput,
                                callback: function($$v) {
                                  _vm.myInput = $$v
                                },
                                expression: "myInput"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "lists" }, [
                  _vm.lists.length === 0
                    ? _c("div", { staticClass: "my-popover empty-wrapper" }, [
                        _c("img", {
                          attrs: { src: _vm.image.noData, alt: "" }
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无数据")])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.lists.length > 0
                    ? _c(
                        "ul",
                        {
                          directives: [
                            {
                              name: "infinite-scroll",
                              rawName: "v-infinite-scroll",
                              value: _vm.getGroupLists,
                              expression: "getGroupLists"
                            }
                          ],
                          attrs: {
                            "infinite-scroll-disabled": "infiniteDisabled"
                          }
                        },
                        _vm._l(_vm.lists, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass: "list",
                              class: item.active ? "active" : "",
                              attrs: { type: "flex" },
                              on: {
                                click: function($event) {
                                  return _vm.toListDetail(item, index)
                                }
                              }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 5 } },
                                [
                                  _c("el-avatar", {
                                    staticClass: "list-avatar",
                                    attrs: {
                                      size: 45,
                                      src: _vm.image.groupAvatar
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    "padding-left": "0",
                                    "padding-right": "0px"
                                  },
                                  attrs: { span: 19 }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      attrs: {
                                        type: "flex",
                                        justify: "space-between"
                                      }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        { staticClass: "list-title" },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(item.exceptionOrderNo) +
                                              "\n                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                          attrs: { span: 4 }
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              staticClass: "my-tag list-time",
                                              attrs: {
                                                type: _vm._f(
                                                  "filterOrderTypeColor"
                                                )(item.orderType)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm._f("filterOrderType")(
                                                      item.orderType
                                                    )
                                                  ) +
                                                  "\n                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "list-subtitle" }, [
                                    _c("div", { staticClass: "list-desc" }, [
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.description) +
                                          "\n                  "
                                      )
                                    ])
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "index-chat", attrs: { span: 15 } }, [
                _vm.isClick
                  ? _c("div", { staticClass: "chatIframe" }, [
                      _vm.isChatShow
                        ? _c("iframe", {
                            ref: "iframe",
                            staticStyle: {
                              "background-color": "#ffffff",
                              width: "100%",
                              height: "100%"
                            },
                            attrs: {
                              id: "iframeId",
                              src: _vm.iframeUrl,
                              frameborder: "0"
                            },
                            on: { load: _vm.iframeLoad }
                          })
                        : _c("div", [
                            _c("div", { staticClass: "not-chat-wrapper" }, [
                              _vm._v("当前问题单未创建群聊")
                            ])
                          ])
                    ])
                  : _c("div", { staticClass: "not-chat-wrapper" }, [
                      _vm._v(
                        "\n          请点击左边列表项显示聊天内容\n        "
                      )
                    ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "index-right", attrs: { span: 7 } },
            [
              _c(
                "el-tabs",
                { attrs: { type: "card" } },
                [
                  _c(
                    "el-tab-pane",
                    {
                      key: "1",
                      staticClass: "tabContent",
                      attrs: { label: _vm.tabName1 }
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "异常类型" }
                            },
                            [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("filterType")(
                                      _vm.abnormalOption.type
                                    )
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "处理状态" }
                            },
                            [
                              _vm.abnormalOption.processStatus
                                ? _c(
                                    "el-tag",
                                    {
                                      staticClass: "my-tag",
                                      attrs: { type: "success" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.abnormalOption.processStatus)
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "异常描述" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.abnormalOption.description) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "当前处理人" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.abnormalOption.handler
                                      ? _vm.abnormalOption.handler.handler
                                      : ""
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "创建人" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.abnormalOption.created.createdByName
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "解决时间" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.abnormalOption.handler
                                      ? _vm.abnormalOption.handler
                                          .resolutionTime
                                      : ""
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "更新时间" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.abnormalOption.handler
                                      ? _vm.abnormalOption.handler.lastUpdatedAt
                                      : ""
                                  ) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "创建时间" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.abnormalOption.created.createdAt) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }, [
                            _c("div", { staticClass: "log-title" }, [
                              _vm._v("操作日志")
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "log-content" }, [
                              _vm.abnormalOption.operations.length === 0
                                ? _c(
                                    "div",
                                    { staticClass: "my-popover empty-wrapper" },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.image.noData,
                                          alt: ""
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("暂无数据")])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.abnormalOption.operations.length > 0
                                ? _c(
                                    "ul",
                                    { staticClass: "my-popover" },
                                    _vm._l(
                                      _vm.abnormalOption.operations,
                                      function(item, index) {
                                        return _c(
                                          "el-row",
                                          { key: index, staticClass: "li" },
                                          [
                                            _c(
                                              "el-col",
                                              { attrs: { span: 3 } },
                                              [
                                                _c("el-avatar", {
                                                  staticClass: "log-avatar",
                                                  attrs: {
                                                    src: _vm.image.groupAvatar
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-col",
                                              { attrs: { span: 16 } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "log-name" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(item.operatorName)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "log-description"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(item.content) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "log-time" },
                                              [_vm._v(_vm._s(item.createdAt))]
                                            )
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  )
                                : _vm._e()
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    {
                      key: "2",
                      staticClass: "tabContent",
                      attrs: { label: _vm.tabName2 }
                    },
                    [
                      _c(
                        "el-form",
                        { attrs: { "label-width": "80px" } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "锐锢编码" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.afterOrderOption.bianma) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "商品名称" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.afterOrderOption.iName) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "商品单位" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.afterOrderOption.unitName) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "商品单价" }
                            },
                            [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(
                                  "¥ " +
                                    _vm._s(_vm.afterOrderOption.purchasePrice)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "申请数量" }
                            },
                            [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(_vm.afterOrderOption.countMin))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "申请金额" }
                            },
                            [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(_vm.afterOrderOption.totalMoney))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "问题描述" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.afterOrderOption.description) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "售后图片" }
                            },
                            [
                              _vm.afterOrderOption.imgs.length === 0
                                ? _c("span", [_vm._v("暂时不提供图片")])
                                : _vm._l(_vm.afterOrderOption.imgs, function(
                                    item,
                                    index
                                  ) {
                                    return _c("img", {
                                      key: index,
                                      staticClass: "small-image",
                                      attrs: { src: item, alt: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.imagePreview(item)
                                        }
                                      }
                                    })
                                  })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "clearfix",
                              attrs: { label: "物流单号" }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.afterOrderOption.fromBillNo) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgPreview,
            title: "图片预览",
            modal: false,
            width: "40%",
            "custom-class": "custom-dialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.imgPreview = $event
            }
          }
        },
        [_c("img", { attrs: { src: _vm.dialogSrc } })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-484b5214", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-484b5214","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/orderForChat/orderList.vue
// module id = null
// module chunks = 